import { render, staticRenderFns } from "./NextVideoSide.vue?vue&type=template&id=07ecdaa0&scoped=true&"
import script from "./NextVideoSide.vue?vue&type=script&lang=js&"
export * from "./NextVideoSide.vue?vue&type=script&lang=js&"
import style0 from "./NextVideoSide.vue?vue&type=style&index=0&id=07ecdaa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ecdaa0",
  null
  
)

export default component.exports